document.addEventListener("DOMContentLoaded", () => {
  try {
    // Show reminder banner for wholesale applicants
    if (localStorage.getItem("wh_candidate") === "1") {
      const bar = document.createElement("div")
      bar.className = "wh-remember"
      bar.style.cssText = "background:#111;color:#fff;padding:10px;text-align:center;font:500 14px/1.4 system-ui;position:relative;z-index:1000"
      bar.innerHTML = 'Wholesale applicant — <a href="/pages/wholesale-application" style="color:#fff;text-decoration:underline">finish application</a> or <a href="/account/login" style="color:#fff;text-decoration:underline">sign in</a>'
      document.body.prepend(bar)
    }
    
    // Track clicks on wholesale application links
    const applyLinks = document.querySelectorAll('[data-wh-apply="1"]')
    applyLinks.forEach(a => a.addEventListener("click", () => {
      try { localStorage.setItem("wh_candidate", "1") } catch {}
    }))
    
    // Track form interactions on wholesale application form
    const wholesaleForm = document.querySelector('#whForm')
    if (wholesaleForm) {
      // Mark as candidate when they start filling the form
      wholesaleForm.addEventListener('focusin', (e) => {
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') {
          try { localStorage.setItem("wh_candidate", "1") } catch {}
        }
      })
      
      // Clear candidate status when form is successfully submitted
      wholesaleForm.addEventListener('submit', () => {
        // Wait a moment for form submission to process
        setTimeout(() => {
          try { localStorage.removeItem("wh_candidate") } catch {}
        }, 2000)
      })
    }
    
    // Smooth scroll to wholesale form when clicking reminder link
    document.addEventListener('click', (e) => {
      if (e.target.matches('a[href="/pages/wholesale-application"]')) {
        // Let the link work normally to go to the wholesale application page
        // The form will be on that page
      }
    })
    
  } catch {}
})
